import React from "react";
import { Link } from "react-router-dom";
import Studentinfo from "../Components/Studentinfo";
import ContactDiv from "../Components/ContactDiv";
import TodaysThought from "../Dashboard/TodaysThought.jsx";

// Retrieve sessionId from localStorage
const sessionId = localStorage.getItem("currentSessionId");
const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Main Container - All UI inside this */}
      <div className="w-full max-w-7xl mx-auto px-4 py-5">
        {/* Student Card */}
        <div className="mb-5">
          <Studentinfo />
        </div>
 <TodaysThought sessionId={sessionId} />
        {/* Quick Actions Row */}
        <div className="bg-white rounded-xl p-4 shadow-sm border mb-6">
          <h2 className="font-semibold text-gray-700 text-lg mb-3">Quick Actions</h2>
          <div className="flex overflow-x-auto gap-4 hide-scrollbar pb-2">
            {[ 
              { to: "/student-homework", icon: "fa-pencil", label: "Homework", color: "bg-blue-500" },
              { to: "/test-schedule", icon: "fa-clock", label: "Today's Tests", color: "bg-purple-500" },
              { to: "/notifications-announcements", icon: "fa-bullhorn", label: "Announcements", color: "bg-yellow-500" },
            ].map((item, i) => (
              <Link to={item.to} key={i} className="flex-shrink-0">
                <div className={`${item.color} text-white rounded-lg px-4 py-3 flex items-center gap-2 shadow`}>
                  <i className={`fas ${item.icon}`}></i>
                  <span>{item.label}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
        {/* Menu Section */}
        <div className="bg-white rounded-xl p-4 shadow-sm border">
          <h2 className="font-semibold text-gray-700 text-lg mb-4">Menu</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {[ 
              { to: "/student-achievement", icon: "fa-trophy", color: "bg-yellow-100", text: "Student Achievement" },
              { to: "/notifications-announcements", icon: "fa-bell", color: "bg-blue-100", text: "Notifications" },
              { to: "/event-activities", icon: "fa-calendar-alt", color: "bg-green-100", text: "Events" },
              { to: "/student-homework", icon: "fa-pencil", color: "bg-red-100", text: "Homework" },
              { to: "/test-schedule", icon: "fa-clock", color: "bg-purple-100", text: "Test Schedule" },
              { to: "/aboutschool", icon: "fa-school", color: "bg-pink-100", text: "About School" },
            ].map((item, i) => (
              <Link to={item.to} key={i}>
                <div className="p-3 rounded-xl border bg-gray-50 hover:bg-gray-100 transition shadow-sm">
                  <div className="flex items-center gap-2">
                    <div className={`${item.color} rounded-lg p-2`}>
                      <i className={`fas ${item.icon} text-gray-700`}></i>
                    </div>
                    <h3 className="text-gray-800 font-semibold text-xs">{item.text}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="mt-6 mb-20">
          <ContactDiv />
        </div>
      </div>

      {/* Mobile Bottom Nav */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 bg-white border-t py-2 shadow-md">
        <div className="flex justify-around">
          <Link to="/student/dashboard" className="flex flex-col items-center text-blue-600">
            <i className="fas fa-home"></i>
            <span className="text-xs mt-1">Home</span>
          </Link>
          <Link to="/student-homework" className="flex flex-col items-center text-gray-600">
            <i className="fas fa-pencil"></i>
            <span className="text-xs mt-1">Tasks</span>
          </Link>
          <Link to="/test-schedule" className="flex flex-col items-center text-gray-600">
            <i className="fas fa-clock"></i>
            <span className="text-xs mt-1">Schedule</span>
          </Link>
          <Link to="/profile" className="flex flex-col items-center text-gray-600">
            <i className="fas fa-user"></i>
            <span className="text-xs mt-1">Profile</span>
          </Link>
        </div>
      </div>

      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default Dashboard;
